<div class="glai-container">
  <!-- MOBILE NAV -->
  <div class="mobile-nav d-lg-none">
    <div class="fs-10 color-tertiary mt-3 text-nowrap">AI MODE</div>
    <div
      class="custom-select"
      [class.open]="customCollapsed"
      (click)="toggleCustomCollapsed()">
      <div class="custom-select__trigger">
        <div>{{ selectedPath }}</div>
        <i *ngIf="!customCollapsed" class="bi bi-caret-up-fill"></i>
        <i *ngIf="customCollapsed" class="bi bi-caret-down-fill"></i>
      </div>
      <ul class="custom-options">
        <li (click)="toggleMode('default')" class="custom-option">
          Question & Answer
        </li>
        <li (click)="toggleMode('lesson_planning')" class="custom-option">
          Lesson & Activity Planning
        </li>
        <li (click)="toggleMode('diff_and_mods')" class="custom-option">
          Differentiation and Modifications
        </li>
        <li
          (click)="toggleMode('assessments_and_feedback')"
          class="custom-option">
          Assessments and Feedback
        </li>
        <li (click)="toggleMode('communication')" class="custom-option">
          Professional Communication
        </li>
      </ul>
    </div>
  </div>
  <div class="mode-card top">
    <div class="d-flex justify-content-start align-items-center">
      <div class="ai-mode fs-10 color-tertiary me-3 text-nowrap">AI MODE</div>
      <button
        class="btn btn-aimode"
        [class.active]="activeModes.includes('default')"
        (click)="toggleMode('default')">
        <i
          class="bi"
          [ngClass]="
            activeModes.includes('default') ? 'bi-chat-fill' : 'bi-chat'
          "></i
        >Question & Answer
      </button>
      <button
        class="btn btn-aimode"
        [class.active]="activeModes.includes('lesson_planning')"
        (click)="toggleMode('lesson_planning')">
        <i
          class="bi"
          [ngClass]="
            activeModes.includes('lesson_planning') ? 'bi-book-fill' : 'bi-book'
          "></i
        >Lesson & Activity Planning
      </button>
      <button
        class="btn btn-aimode"
        [class.active]="activeModes.includes('diff_and_mods')"
        (click)="toggleMode('diff_and_mods')">
        <i
          class="bi"
          [ngClass]="
            activeModes.includes('diff_and_mods')
              ? 'bi-people-fill'
              : 'bi-people'
          "></i
        >Differentiation and Modifications
      </button>
      <button
        class="btn btn-aimode"
        [class.active]="activeModes.includes('assessments_and_feedback')"
        (click)="toggleMode('assessments_and_feedback')">
        <i
          class="bi"
          [ngClass]="
            activeModes.includes('assessments_and_feedback')
              ? 'bi-clipboard-check-fill'
              : 'bi-clipboard-check'
          "></i
        >Assessments and Feedback
      </button>
      <button
        class="btn btn-aimode"
        [class.active]="activeModes.includes('communication')"
        (click)="toggleMode('communication')">
        <i
          class="bi"
          [ngClass]="
            activeModes.includes('communication')
              ? 'bi-envelope-fill'
              : 'bi-envelope'
          "></i
        >Professional Communication
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="messages-container" #messagesContainer>
        <ng-container *ngFor="let message of messages">
          <ng-container *ngIf="message.role === 'user'">
            <div class="message-wrapper">
              <div class="message user-message">
                <div class="message-content">
                  <markdown>{{ message.content }}</markdown>
                </div>
                <ng-container *ngFor="let file of message.files">
                  <div class="file-attachment">{{ file.name }}</div>
                </ng-container>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="message.role === 'assistant'">
            <div class="message-wrapper">
              <div class="d-flex align-items-center">
                <div>
                  <img
                    src="/assets/icon-ai-assistant-sm.svg"
                    class="ai-icon me-4"
                    alt="AI Assistant" />
                </div>
                <div class="message ai-message">
                  <div *ngIf="message.thinking" class="thinking-content">
                    {{ message.thinking }}
                  </div>
                  <div class="message-content">
                    <markdown>{{ message.content }}</markdown>
                  </div>
                  <div class="action-btns">
                    <button class="btn-reset px-2" ngbTooltip="Copy">
                      <i
                        class="bi bi-copy"
                        (click)="copyMessage(message.content, $event)"></i>
                    </button>
                    <button
                      class="btn-reset px-2"
                      ngbTooltip="Good Response"
                      (click)="
                        submitUserFeedback(message, AIUserFeedback.THUMBS_UP)
                      ">
                      <i
                        class="bi"
                        [ngClass]="
                          ratedThumbsUp
                            ? 'bi-hand-thumbs-up-fill'
                            : 'bi-hand-thumbs-up'
                        "></i>
                    </button>
                    <button
                      class="btn-reset px-2"
                      ngbTooltip="Bad Response"
                      (click)="
                        submitUserFeedback(message, AIUserFeedback.THUMBS_DOWN)
                      ">
                      <i
                        class="bi"
                        [ngClass]="
                          ratedThumbsDown
                            ? 'bi-hand-thumbs-down-fill'
                            : 'bi-hand-thumbs-down'
                        "></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<div class="glai-prompt">
  <div class="d-flex align-items-center">
    <div class="input-file">
      <app-file-upload
        #uploadComponent
        [uploadType]="uploadType"
        [style]="uploadStyle"
        (outputFiles)="addToFileList($event); fileUploads.emit($event)" />
    </div>
    <input
      type="text"
      class="input-msg"
      [(ngModel)]="userMessage"
      (keyup.enter)="sendMessage()"
      [disabled]="isLoading"
      placeholder="Ask me anything..." />
    <button
      class="btn btn-primary input-btn"
      (click)="sendMessage()"
      [disabled]="isLoading || !userMessage.trim()">
      <i *ngIf="!isLoading" class="bi bi-send"></i>
      <i *ngIf="isLoading" class="bi bi-hourglass-split"></i>
    </button>
  </div>
  <ng-container *ngIf="uploadedFiles">
    <div
      *ngIf="uploadedFiles.length === 0"
      class="tip text-center fs-12 pt-3 color-tertiary">
      💡 Tip: Attach images or documents, ask follow-up questions, or switch
      modes anytime
    </div>
    <div *ngIf="uploadedFiles.length > 0" class="file-list-wrapper">
      <app-file-list
        (deletedFile)="removeFromFileList($event)"
        [fileList]="uploadedFiles"></app-file-list>
    </div>
  </ng-container>
</div>
